import React, { useContext } from 'react';
import { Content } from './styles';
import { ThemeContext } from 'styled-components';

const Header = props => {
  return (
    <Content height={34} width={1060} speed={1.2} {...props}>
      <rect x="55" y="8" rx="0" ry="0" width={20} height={12} />
      <rect x="120" y="8" rx="0" ry="0" width={26} height={12} />
      <rect x="560" y="8" rx="0" ry="0" width={20} height={12} />
      <rect x="630" y="8" rx="0" ry="0" width={35} height={12} />
      <rect x="935" y="8" rx="0" ry="0" width={40} height={12} />
    </Content>
  );
};
const TableRow = props => {
  const random = Math.random() * (1 - 0.7) + 0.7;
  return (
    <Content
      height={34}
      width={1060}
      speed={1.2}
      {...props}
      viewBox="0 0 1060 34"
    >
      <rect x="5" y="8" rx="0" ry="0" width={10} height="25" />
      <rect x="55" y="8" rx="6" ry="6" width={35} height="10" />
      <rect x="120" y="8" rx="6" ry="6" width={200 * random} height="10" />
      <rect x="560" y="6" rx="3" ry="3" width={65} height="16" />
      <rect x="630" y="6" rx="3" ry="3" width={90} height="16" />
      <rect x="948" y="8" rx="8" ry="8" width={38} height="16" />
      <rect x="1030" y="8" rx="3" ry="3" width={8} height="16" />
    </Content>
  );
};

const Table = () => {
  const themeContext = useContext(ThemeContext);

  return (
    <>
      <Header
        backgroundColor={themeContext?.loadingTableColor}
        foregroundColor={themeContext?.loadingTableColor}
        primaryopacity={1}
        secondaryopacity={0.6}
      />
      {Array(7)
        .fill('')
        .map((e, i) => (
          <TableRow
            key={i}
            style={{ opacity: Number(2 / i).toFixed(1) }}
            backgroundColor={themeContext?.loadingTableColor}
            foregroundColor={themeContext?.loadingTableColor}
            primaryopacity={1}
            secondaryopacity={0.6}
          />
        ))}
    </>
  );
};

export default Table;
